module.exports = __webpack_public_path__ + "img/img-advisoryboard1@2x.842f91b3.jpg";